<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="evidencesSelo"
      class="elevation-1"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:item="{ item }">
        <tr
          :class="
            item.rejeitada ? 'rejeitado' : item.aprovada ? 'aprovado' : ''
          "
        >
          <td>{{ item.nomeArquivo }}</td>
          <td>
            <div v-if="readonly || item.enviada">
              {{ item.justificativa }}
            </div>

            <v-text-field
              v-else
              label="Justificativa"
              name="justificativa"
              type="text"
              required
              v-model="item.justificativa"
            ></v-text-field>
          </td>
          <td>
            <v-btn
              v-if="
                !readonly &&
                item.enviada !== true &&
                (isFullAdmin ||
                  ((filtro === 'evidenciada' || filtro === 'rejeitada') &&
                    groupsConfig[`analisar${type}`] &&
                    config[`analisar${type}`]))
              "
              :outlined="!item.aprovada"
              color="azulclarosc"
              :style="{ color: item.aprovada && '#fff' }"
              class="ml-3 buttonCustom"
              @click="evaluateIssue(item, true)"
            >
              <span>Aprovar</span>
            </v-btn>

            <v-btn
              v-if="
                !readonly &&
                item.enviada !== true &&
                (isFullAdmin ||
                  ((filtro === 'evidenciada' || filtro === 'aprovada') &&
                    groupsConfig[`analisar${type}`] &&
                    config[`analisar${type}`]))
              "
              :outlined="!item.rejeitada"
              color="error"
              class="ml-3 buttonCustom"
              @click="evaluateIssue(item, false)"
            >
              <span>Rejeitar</span>
            </v-btn>

            <v-btn
              color="primary"
              style="color: #fff"
              class="ml-3 buttonCustom"
              @click="downloadEvidence(item)"
            >
              <span>Ver Evidência</span>
            </v-btn>
          </td>
          <td v-if="item.aprovada === true">
            <div class="hasEvidence" title="aprovado"></div>
          </td>
          <td v-else-if="item.rejeitada === true">
            <div class="hasNoEvidence" title="rejeitado"></div>
          </td>
          <td v-else>
            <div class="semStatus" title="sem status"></div>
          </td>
        </tr>
      </template>

      <template slot="no-data">
        <span> Nenhuma evidência retornada </span>
      </template>
    </v-data-table>
    <div style="display: flex; justify-content: flex-end" v-if="!readonly">
      <v-btn
        color="azulclarosc"
        @click="$emit('finalizar', evidencesSelo)"
        style="color: #fff; margin: 10px"
        class="ml-3"
        v-if="
          isFullAdmin ||
          (config.analisarEvidenciadas && groupsConfig.analisarEvidenciadas)
        "
      >
        Finalizar avaliação
      </v-btn>
    </div>
  </div>
</template>

<script>
import { cityQuestionAPI } from "@/modules/city";
import { evidenceQuestionAPI } from "@/modules/evidence";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "AppGetEvidenceQuestion",
  props: {
    perguntaId: { type: Number, required: true, default: null },
    evidences: { type: Array, default: () => [] },
    type: { type: String, required: true, default: "" },
    readonly: { type: Boolean, default: false },
  },

  data() {
    return {
      headers: [
        { text: "Nome do Arquivo de Evidência", value: "nomeArquivo" },
        { text: "Justificativa", value: "justificativa" },
        { text: "Ações", value: "acoes" },
        { text: "Status", value: "status" },
      ],
      payload: {
        municipioId: this.$route.params.id,
      },
      evidencias: [],
      filtro: "evidenciada",
      activeBtn: 0,
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadQuestion() {
      this.setLoading(true);
      cityQuestionAPI
        .getPergunta(this.perguntaId)
        .then((resp) => {
          this.evidencias = resp.data.evidencias;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },
    evaluateIssue(evidencia, situacao) {
      if (situacao === true) {
        evidencia.aprovada = true;
        evidencia.rejeitada = false;
      } else {
        if (!evidencia.justificativa) {
          this.$notification.error(
            "É obrigatório o preenchimento de uma justificativa para evidencias rejeitadas!"
          );
          return;
        }
        evidencia.rejeitada = true;
        evidencia.aprovada = false;
      }

      let formData = new FormData();

      formData.append("aprovada", evidencia.aprovada);
      formData.append("nomeArquivo", evidencia.nomeArquivo);
      formData.append("perguntaEvidenciaId", evidencia.perguntaEvidenciaId);
      formData.append("perguntaMunicipioId", evidencia.perguntaMunicipioId);
      formData.append("rejeitada", evidencia.rejeitada);
      formData.append("usuarioId", evidencia.usuarioId);
      formData.append("Justificativa", evidencia.justificativa || "");

      this.setLoading(true);
      evidenceQuestionAPI
        .update(formData)
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success("Evidência avaliada com sucesso!");
          this.loadQuestion();
          this.$emit("updateValue", evidencia);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao avaliar evidência");
        });
    },
    update(evidencia) {
      this.setLoading(true);
      evidenceQuestionAPI
        .update(evidencia)
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success("Evidência atualizada com sucesso!");
          this.loadQuestion();
          this.$emit("updateValue", evidencia);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao atualizar evidência");
        });
    },
    downloadEvidence(evidence) {
      evidenceQuestionAPI
        .download(evidence.perguntaEvidenciaId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          // link.download = evidence.nomeArquivo;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter evidencia");
        });
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(["isAdmin", "isFullAdmin"]),
    evidencesSelo() {
      return this.evidences.sort((a, b) => {
        return (
          Number(a.aprovada) - Number(b.aprovada) ||
          Number(a.rejeitada) - Number(b.rejeitada)
        );
      });
    },
  },
};
</script>

<style>
.buttonCustom {
  font-size: 12px !important;
  padding: 0 10px !important;
}
.rejeitado {
  background: #f1b1b1;
}

.aprovado {
  background: #9bd29e;
}
</style>
<style scoped></style>
